module.exports = __webpack_public_path__ + "static/media/tk.2dd578e2.webp";